import api from './api';

/**
 * @param {string} taskType
 * @param {*} body (Body format is taskType-specific)
 * @returns {Promise<unknown>} TaskType-specific response
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tasks-postTaskItems
 */
export default async function createNewTask(level_id, taskType, body) {

    body.items = body.items.map(item => {
        if (taskType === 'scene_creation' && item.question !== null) {
            if (item?.question.trim() === '' || item.question === undefined) {
                item.question = null;
            }
        }
        return item;
    });

    const { data } = await api.post(
        `levels/${level_id}/task_types/${taskType}/tasks/items`,
        body
    );

    return data;
}